import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import SalesTransactionsList from './SalesTransactionsList';
import { SalesTransactionsHubProvider } from './SalesTransactionsHubContext';

const DRAWER_OPEN_PATTERN =
  /^\/sales-transactions\/(view\/|invoice\/|payment\/|quotation\/)/;

const SalesTransactionsLayout = () => {
  const { pathname } = useLocation();
  const overlayOpen = DRAWER_OPEN_PATTERN.test(pathname);

  return (
    <SalesTransactionsHubProvider>
      <div className="h-screen w-full bg-gray-100 flex overflow-hidden">
        <Sidebar />
        <main className="flex-1 flex flex-col min-h-0 overflow-hidden p-4 md:p-6 relative">
          <div
            className={`flex-1 flex flex-col min-h-0${
              overlayOpen ? ' pointer-events-none select-none opacity-60' : ''
            }`}
            aria-hidden={overlayOpen}
          >
            <SalesTransactionsList />
          </div>
          <Outlet />
        </main>
      </div>
    </SalesTransactionsHubProvider>
  );
};

export default SalesTransactionsLayout;
